export const LEVEL_1 = [
  {
    actual: "please",
    scrambled: "lepeas",
    clue: "Cause to feel happy and satisfied.",
  },
  {
    actual: "courtesy",
    scrambled: "cosetryu",
    clue: "Polite behaviour, or a polite action or remark.",
  },
  {
    actual: "apple",
    scrambled: "pepla",
    clue: "This fruit fell on Newton's head.",
  },
  {
    actual: "tiger",
    scrambled: "retgi",
    clue: "Burning bright, in the forests of the night.",
  },
  {
    actual: "cream",
    scrambled: "macer",
    clue: "Fatty part of milk.",
  },
  {
    actual: "matter",
    scrambled: "tatrem",
    clue: "Anything that has mass and volume.",
  },
  {
    actual: "snowy",
    scrambled: "ywnso",
    clue: "Winters are generally...",
  },
  {
    actual: "chocolate",
    scrambled: "chaceloto",
    clue: "Made from roasted and ground cacao seeds.",
  },
  {
    actual: "kicked",
    scrambled: "deckki",
    clue: "Hit forcibly with the foot.",
  },
  {
    actual: "believe",
    scrambled: "eveelbi",
    clue: "Accept that something is true, especially without proof.",
  },
  {
    actual: "storm",
    scrambled: "morts",
    clue:
      "A violent disturbance of the atmosphere with strong winds and usually rain, thunder, lightning, or snow.",
  },
  {
    actual: "morning",
    scrambled: "mingnor",
    clue:
      "The period of time between midnight and noon, especially from sunrise to noon.",
  },
  {
    actual: "noisy",
    scrambled: "ysoni",
    clue: "Making a lot of noise.",
  },
  {
    actual: "potato",
    scrambled: "taotop",
    clue: "Couch what?",
  },
  {
    actual: "seconds",
    scrambled: "condess",
    clue: "Base unit of time in the International System of Units.",
  },
  {
    actual: "summer",
    scrambled: "umrmes",
    clue: "Warmest season of the year.",
  },
  {
    actual: "funny",
    scrambled: "nyunf",
    clue: "Humorous.",
  },
  {
    actual: "elephant",
    scrambled: "thanelep",
    clue: "Largest land animal.",
  },
  {
    actual: "jasmine",
    scrambled: "jinsame",
    clue: "Flower famous for its scented oil and perfume.",
  },
  {
    actual: "wheat",
    scrambled: "wetah",
    clue: "A cereal grain which is a worldwide staple food.",
  },
  {
    actual: "cheese",
    scrambled: "seeech",
    clue: "Cheddar, parmesan and mozzarella.",
  },
  {
    actual: "faith",
    scrambled: "ifhat",
    clue: "Complete trust or confidence in someone or something.",
  },
  {
    actual: "beautiful",
    scrambled: "faibleutu",
    clue: "Pleasing the senses or mind aesthetically.",
  },
  {
    actual: "princess",
    scrambled: "crispens",
    clue: "The daughter of a monarch.",
  },
  {
    actual: "knight",
    scrambled: "giknth",
    clue:
      "A man who served his sovereign or lord as a mounted soldier in armour.",
  },
];
export const LEVEL_2 = [
  {
    actual: "football",
    scrambled: "tolaflob",
    clue: "World's most popular sport.",
  },
  {
    actual: "music",
    scrambled: "sucmi",
    clue: "An art form, and cultural activity, whose medium is sound.",
  },
  {
    actual: "school",
    scrambled: "loshoc",
    clue: "An institution for educating children.",
  },
  {
    actual: "zebra",
    scrambled: "braze",
    clue: "An African wild horse with black-and-white stripes.",
  },
  {
    actual: "water",
    scrambled: "tawer",
    clue: "3/4 th of Earth is covered by this.",
  },
  {
    actual: "minutes",
    scrambled: "mistune",
    clue: "A period of time equal to sixty seconds.",
  },
  {
    actual: "mushroom",
    scrambled: "humsmoor",
    clue:
      "Conspicuous umbrella-shaped fruiting body of certain fungi that you can eat.",
  },
  {
    actual: "candy",
    scrambled: "dancy",
    clue: "Confectionery.",
  },
  {
    actual: "swimming",
    scrambled: "miwingsm",
    clue:
      "The sport or activity of propelling oneself through water using the limbs.",
  },
  {
    actual: "afternoon",
    scrambled: "nonfatore",
    clue: "The time from noon or lunchtime to evening.",
  },
  {
    actual: "lyrics",
    scrambled: "clysri",
    clue: "The words of a song.",
  },
  {
    actual: "cycle",
    scrambled: "leccy",
    clue: "A series of events that are regularly repeated in the same order.",
  },
  {
    actual: "building",
    scrambled: "unlidgib",
    clue: "A structure with a roof and walls, such as a house or factory.",
  },
  {
    actual: "bottle",
    scrambled: "teltob",
    clue:
      "A glass or plastic container, used for storing drinks or other liquids.",
  },
  {
    actual: "sunshine",
    scrambled: "neshsuni",
    clue: "Sunlight.",
  },
  {
    actual: "vacation",
    scrambled: "cavaoint",
    clue: "Holiday period.",
  },
  {
    actual: "holiday",
    scrambled: "hyoidal",
    clue:
      "An extended period of leisure and recreation, especially one spent away from home or in travelling.",
  },
  {
    actual: "computer",
    scrambled: "courempt",
    clue:
      "An electronic device for storing and processing data, typically in binary form.",
  },
  {
    actual: "chair",
    scrambled: "archi",
    clue: "A seat typically having four legs and a back for one person.",
  },
  {
    actual: "sports",
    scrambled: "orspst",
    clue:
      "An athletic activity requiring skill or physical prowess and often of a competitive nature.",
  },
  {
    actual: "magic",
    scrambled: "gamic",
    clue:
      "The power of apparently influencing events by using mysterious or supernatural forces.",
  },
  {
    actual: "thank",
    scrambled: "tkanh",
    clue: "Express gratitude to someone.",
  },
  {
    actual: "remind",
    scrambled: "nidrem",
    clue: "Cause (someone) to remember someone or something.",
  },
  {
    actual: "giraffe",
    scrambled: "rifegaf",
    clue: "A large African mammal with a very long neck and forelegs.",
  },
  {
    actual: "stars",
    scrambled: "tsars",
    clue:
      "A fixed luminous point in the night sky which is a large, remote incandescent body like the sun.",
  },
];
export const LEVEL_3 = [
  {
    actual: "adventure",
    scrambled: "detenuvar",
    clue: "An unusual and exciting or daring experience.",
  },
  {
    actual: "examination",
    scrambled: "taximennaoi",
    clue: "A detailed inspection or study.",
  },
  {
    actual: "student",
    scrambled: "nettuds",
    clue: "A school or college pupil.",
  },
  {
    actual: "employee",
    scrambled: "peeoymel",
    clue: "Someone who gets paid to work for a person or company.",
  },
  {
    actual: "ground",
    scrambled: "nugdor",
    clue: "The solid surface of the Earth.",
  },
  {
    actual: "tower",
    scrambled: "owtre",
    clue:
      "A tall, narrow building, that either stands alone or forms part of another building.",
  },
  {
    actual: "kingdom",
    scrambled: "dimgonk",
    clue: "A country, state, or territory ruled by a king or queen.",
  },
  {
    actual: "beverage",
    scrambled: "grebevae",
    clue: "A drink other than water.",
  },
  {
    actual: "celebrate",
    scrambled: "abletcree",
    clue: "To express admiration and approval for something or someone.",
  },
  {
    actual: "backyard",
    scrambled: "drabyack",
    clue: "A back garden.",
  },
  {
    actual: "awesome",
    scrambled: "owesmae",
    clue: "Extremely impressive.",
  },
  {
    actual: "invite",
    scrambled: "vietin",
    clue: "To request the presence or participation of.",
  },
  {
    actual: "sorted",
    scrambled: "rostde",
    clue: "An exclamation of satisfaction.",
  },
  {
    actual: "television",
    scrambled: "envoislite",
    clue:
      "An electronic device used to receive sound and images which create television programs that people watch.",
  },
  {
    actual: "aeroplane",
    scrambled: "reponeala",
    clue:
      "A powered flying vehicle with fixed wings and a weight greater than that of the air it displaces.",
  },
  {
    actual: "orange",
    scrambled: "regoan",
    clue: "A colour between yellow and red on the spectrum of visible light.",
  },
  {
    actual: "monument",
    scrambled: "munmoten",
    clue:
      "A statue, building, or other structure erected to commemorate a notable person or event.",
  },
  {
    actual: "mythology",
    scrambled: "hootyglym",
    clue: "The study of myths.",
  },
  {
    actual: "stadium",
    scrambled: "tuismad",
    clue: "An athletic or sports ground with tiers of seats for spectators.",
  },
  {
    actual: "arena",
    scrambled: "reaan",
    clue:
      "A place where sports, entertainments, and other public events take place.",
  },
  {
    actual: "tournament",
    scrambled: "moutantern",
    clue:
      "A series of contests between a number of competitors, competing for an overall prize.",
  },
  {
    actual: "lemur",
    scrambled: "merlu",
    clue:
      "An arboreal primate with a pointed snout and typically a long tail, found only in Madagascar.",
  },
  {
    actual: "chemical",
    scrambled: "chiaclem",
    clue: "A substance produced by or used in a chemical process.",
  },
  {
    actual: "factory",
    scrambled: "fryatoc",
    clue:
      "A building or group of buildings where goods are manufactured or assembled chiefly by machine.",
  },
  {
    actual: "atmosphere",
    scrambled: "espartomeh",
    clue: "The envelope of gases surrounding the earth or another planet.",
  },
];
export const LEVEL_4 = [
  {
    actual: "voyage",
    scrambled: "goyave",
    clue: "A long journey involving travel by sea or in space.",
  },
  {
    actual: "superhero",
    scrambled: "repourhes",
    clue: "A fictional hero having extraordinary or superhuman powers.",
  },
  {
    actual: "crystal",
    scrambled: "tarscly",
    clue: "A high-quality glass, usually with patterns cut into its surface.",
  },
  {
    actual: "jaguar",
    scrambled: "rugaja",
    clue: "A large animal of the cat family with dark spots on its back.",
  },
  {
    actual: "pineapple",
    scrambled: "palpipeen",
    clue:
      "A large tropical fruit with a rough orange or brown skin and pointed leaves on top.",
  },
  {
    actual: "party",
    scrambled: "tryap",
    clue:
      "A social gathering of invited guests, typically involving eating, drinking, and entertainment.",
  },
  {
    actual: "mission",
    scrambled: "ismsion",
    clue: "An important assignment given to a person or group of people.",
  },
  {
    actual: "wedding",
    scrambled: "dewding",
    clue:
      "A marriage ceremony, especially considered as including the associated celebrations.",
  },
  {
    actual: "marriage",
    scrambled: "aregrima",
    clue:
      "A legally and socially sanctioned union, usually between a man and a woman.",
  },
  {
    actual: "plastic",
    scrambled: "capstil",
    clue:
      "A synthetic material made from a wide range of organic polymers such as polyethylene, PVC, nylon, etc.",
  },
  {
    actual: "chandelier",
    scrambled: "endarchiel",
    clue:
      "A large, decorative hanging light with branches for several light bulbs or candles.",
  },
  {
    actual: "bunker",
    scrambled: "nekurb",
    clue: "A large container or compartment for storing fuel.",
  },
  {
    actual: "cabinet",
    scrambled: "nabetic",
    clue:
      "A cupboard with shelves or drawers for storing or displaying articles.",
  },
  {
    actual: "dartboard",
    scrambled: "troaddrab",
    clue:
      "A circular board marked with numbered segments, used as a target in the game of darts.",
  },
  {
    actual: "grateful",
    scrambled: "galuterf",
    clue: "Feeling or showing an appreciation for something done or received.",
  },
  {
    actual: "graceful",
    scrambled: "clefgaur",
    clue:
      "Characterized by elegance or beauty of form, manner, movement, or speech.",
  },
  {
    actual: "helicopter",
    scrambled: "tiercelpho",
    clue:
      "A type of rotorcraft in which lift and thrust are supplied by horizontally-spinning rotors.",
  },
  {
    actual: "steamer",
    scrambled: "rametes",
    clue: "A ship, boat, or locomotive powered by steam.",
  },
  {
    actual: "cooker",
    scrambled: "okeorc",
    clue: "An appliance used for cooking food.",
  },
  {
    actual: "mischief",
    scrambled: "himsfice",
    clue:
      "A word for things that are a little bad or reckless but ultimately harmless.",
  },
  {
    actual: "forest",
    scrambled: "serfto",
    clue: "A large area covered chiefly with trees and undergrowth.",
  },
  {
    actual: "panther",
    scrambled: "nerapht",
    clue: "A leopard, especially a black one.",
  },
  {
    actual: "soyabean",
    scrambled: "beysanoa",
    clue: "The most highly proteinaceous vegetable known.",
  },
  {
    actual: "continent",
    scrambled: "citnetnon",
    clue:
      "One of the seven large land masses on the Earth's surface, surrounded or mainly surrounded by sea.",
  },
  {
    actual: "environment",
    scrambled: "vintnermone",
    clue:
      "The surroundings or conditions in which a person, animal, or plant lives or operates.",
  },
];
export const LEVEL_5 = [
  {
    actual: "tinker",
    scrambled: "netkir",
    clue:
      "Someone who repairs, or attempts repair, on anything mechanical, or who invents such devices.",
  },
  {
    actual: "betrothed",
    scrambled: "tthederbo",
    clue: "The person to whom one is engaged.",
  },
  {
    actual: "inclined",
    scrambled: "linncide",
    clue: "Sloping.",
  },
  {
    actual: "satellite",
    scrambled: "tatiesell",
    clue: "A celestial body orbiting the earth or another planet.",
  },
  {
    actual: "habitat",
    scrambled: "itabaht",
    clue:
      "The natural home or environment of an animal, plant, or other organism.",
  },
  {
    actual: "accustomed",
    scrambled: "caumedtocs",
    clue: "Usual.",
  },
  {
    actual: "embarrassed",
    scrambled: "darbarsemes",
    clue: "Feeling awkward.",
  },
  {
    actual: "tuitions",
    scrambled: "ointtuis",
    clue: "Teaching given to a person or a small group.",
  },
  {
    actual: "serene",
    scrambled: "eneers",
    clue: "Calm and peaceful.",
  },
  {
    actual: "loiter",
    scrambled: "toreli",
    clue: "Stand or wait around without apparent purpose.",
  },
  {
    actual: "benevolent",
    scrambled: "voletenben",
    clue: "Kind.",
  },
  {
    actual: "philanthropy",
    scrambled: "naplirothhyp",
    clue: "The desire to promote the welfare of others.",
  },
  {
    actual: "pioneer",
    scrambled: "porenei",
    clue: "A person who is among the first to study or develop something.",
  },
  {
    actual: "harbinger",
    scrambled: "nibarregh",
    clue: "Something that gives an anticipatory sign of what is to come.",
  },
  {
    actual: "swansong",
    scrambled: "awnssnog",
    clue: "The final performance or activity of a person's career.",
  },
  {
    actual: "voracious",
    scrambled: "couraviso",
    clue: "Wanting or devouring great quantities of food.",
  },
  {
    actual: "spaghetti",
    scrambled: "gaittepsh",
    clue: "Pasta made in the form of long, thin strings.",
  },
  {
    actual: "oyster",
    scrambled: "ryesto",
    clue: "A large flat shellfish.",
  },
  {
    actual: "rendezvous",
    scrambled: "zonuresdev",
    clue: "A meeting at an agreed time and place.",
  },
  {
    actual: "surpassed",
    scrambled: "sussedpar",
    clue: "Exceeded.",
  },
  {
    actual: "surprise",
    scrambled: "seirspur",
    clue: "An unexpected or astonishing event.",
  },
  {
    actual: "pavilion",
    scrambled: "voiplain",
    clue:
      "A building at a cricket ground or other sports ground, used for changing and taking refreshments.",
  },
  {
    actual: "gamut",
    scrambled: "tagmu",
    clue: "The complete range or scope of something.",
  },
  {
    actual: "cliche",
    scrambled: "ichcel",
    clue: "Stereotype.",
  },
  {
    actual: "bling",
    scrambled: "nglib",
    clue: "Expensive, ostentatious clothing and jewellery.",
  },
];
export const LEVEL_6 = [
  {
    actual: "goosebumps",
    scrambled: "possumbego",
    clue: "A state of the skin caused by cold, fear, or excitement.",
  },
  {
    actual: "prerogative",
    scrambled: "apeigrretvo",
    clue: "A right or privilege exclusive to a particular individual or class.",
  },
  {
    actual: "incense",
    scrambled: "sicenne",
    clue: "A substance that is burned for the sweet smell it produces.",
  },
  {
    actual: "fragrance",
    scrambled: "acgnarrfe",
    clue: "A pleasant, sweet smell.",
  },
  {
    actual: "extinguish",
    scrambled: "ugnixthies",
    clue: "To bring to an end.",
  },
  {
    actual: "callous",
    scrambled: "lausloc",
    clue: "Showing or having an insensitive and cruel disregard for others.",
  },
  {
    actual: "treason",
    scrambled: "atrones",
    clue: "The crime of betraying one's country.",
  },
  {
    actual: "whistle",
    scrambled: "shewlit",
    clue:
      "To utter a shrill clear sound by blowing or drawing air through the puckered lips.",
  },
  {
    actual: "powerhouse",
    scrambled: "ouphewoser",
    clue: "A person or thing of great energy, strength, or power.",
  },
  {
    actual: "intricate",
    scrambled: "actinrite",
    clue: "Very complicated or detailed.",
  },
  {
    actual: "nascent",
    scrambled: "centnas",
    clue:
      "Just coming into existence and beginning to display signs of future potential.",
  },
  {
    actual: "rogue",
    scrambled: "ugore",
    clue: "Dishonest or unprincipled.",
  },
  {
    actual: "hysterical",
    scrambled: "eltchisary",
    clue: "Affected by or deriving from wildly uncontrolled emotion.",
  },
  {
    actual: "satire",
    scrambled: "ritsea",
    clue: "A humorous way of criticizing people.",
  },
  {
    actual: "glaciers",
    scrambled: "ceilsgar",
    clue: "A slowly moving mass or river of ice.",
  },
  {
    actual: "dungeon",
    scrambled: "gnunoed",
    clue: "A strong underground prison cell, especially in a castle.",
  },
  {
    actual: "charades",
    scrambled: "escarhad",
    clue:
      "A game in which players guess a word or phrase from a written or acted clue.",
  },
  {
    actual: "artillery",
    scrambled: "rtaiyrlle",
    clue: "Large-calibre guns used in warfare on land.",
  },
  {
    actual: "reinforcement",
    scrambled: "femirrocenent",
    clue: "The action or process of strengthening.",
  },
  {
    actual: "assessment",
    scrambled: "esnamstess",
    clue: "The action of assessing someone or something.",
  },
  {
    actual: "consecutive",
    scrambled: "eicotvenscu",
    clue: "Following each other continuously.",
  },
  {
    actual: "recliner",
    scrambled: "creenirl",
    clue: "A chair in which you can lean back at different angles.",
  },
  {
    actual: "inculcate",
    scrambled: "leucincat",
    clue: "Instil by persistent instruction.",
  },
  {
    actual: "remedy",
    scrambled: "ermeyd",
    clue: "A medicine or treatment for a disease or injury.",
  },
  {
    actual: "poignant",
    scrambled: "pgoatinn",
    clue: "Evoking a keen sense of sadness or regret.",
  },
];
export const LEVEL_7 = [
  {
    actual: "masquerade",
    scrambled: "quasardeem",
    clue: "A false show or pretence.",
  },
  {
    actual: "charming",
    scrambled: "ganchmir",
    clue: "Very pleasant or attractive.",
  },
  {
    actual: "lieutenant",
    scrambled: "tannietule",
    clue: "A deputy or substitute acting for a superior.",
  },
  {
    actual: "streamline",
    scrambled: "enarmelist",
    clue: "A line along which the flow of a moving fluid is least turbulent.",
  },
  {
    actual: "bewildered",
    scrambled: "welderbide",
    clue: "Perplexed and confused.",
  },
  {
    actual: "embellishment",
    scrambled: "hisbeltmenelm",
    clue:
      "A decorative detail or feature added to something to make it more attractive.",
  },
  {
    actual: "arachnid",
    scrambled: "ranchida",
    clue:
      "Any of a group of small animals, similar to insects but with four pairs of legs.",
  },
  {
    actual: "claustrophobia",
    scrambled: "bopatchouliars",
    clue:
      "A situational phobia triggered by an irrational and intense fear of tight or crowded spaces.",
  },
  {
    actual: "serenade",
    scrambled: "desanere",
    clue:
      "A piece of music sung or played in the open air, typically by a man at night under the window of his beloved.",
  },
  {
    actual: "ascend",
    scrambled: "cansed",
    clue: "Go up or climb.",
  },
  {
    actual: "metamorphosis",
    scrambled: "apterismmohos",
    clue:
      "A change of the form or nature of a thing or person into a completely different one.",
  },
  {
    actual: "possession",
    scrambled: "sooensipss",
    clue: "The state of having, owning, or controlling something.",
  },
  {
    actual: "diligent",
    scrambled: "eildting",
    clue:
      "Having or showing care and conscientiousness in one's work or duties.",
  },
  {
    actual: "obedient",
    scrambled: "teebiond",
    clue: "Complying or willing to comply with an order or request.",
  },
  {
    actual: "historical",
    scrambled: "tischialor",
    clue: "Belonging to the past.",
  },
  {
    actual: "monetary",
    scrambled: "ymenarto",
    clue: "Relating to money or currency.",
  },
  {
    actual: "billionaire",
    scrambled: "oilierblain",
    clue:
      "A person possessing assets worth at least a billion pounds or dollars.",
  },
  {
    actual: "centrifugal",
    scrambled: "flecurating",
    clue: "Moving or tending to move away from a centre.",
  },
  {
    actual: "mockery",
    scrambled: "keromyc",
    clue:
      "Teasing and contemptuous language or behaviour directed at a particular person or thing.",
  },
  {
    actual: "coterie",
    scrambled: "terceoi",
    clue: "A small group of people with shared interests or tastes.",
  },
  {
    actual: "shambles",
    scrambled: "ambhelss",
    clue: "A state of total disorder.",
  },
  {
    actual: "ambiguity",
    scrambled: "bigitayum",
    clue: "The quality of being open to more than one interpretation.",
  },
  {
    actual: "pseudonym",
    scrambled: "osmundyep",
    clue: "A fictitious name, especially one used by an author.",
  },
  {
    actual: "chore",
    scrambled: "roche",
    clue: "A routine task, especially a household one.",
  },
  {
    actual: "flinching",
    scrambled: "ichgiflnn",
    clue:
      "Making a quick, nervous movement as an instinctive reaction to fear, pain, or surprise.",
  },
];
export const LEVEL_8 = [
  {
    actual: "molecule",
    scrambled: "elmleuco",
    clue:
      "A group of atoms bonded together, representing the smallest fundamental unit of a chemical compound.",
  },
  {
    actual: "district",
    scrambled: "rittcids",
    clue:
      "An area of a country or city, especially one characterized by a particular feature or activity.",
  },
  {
    actual: "scientific",
    scrambled: "eticficins",
    clue: "Based on or characterized by the methods and principles of science.",
  },
  {
    actual: "redeem",
    scrambled: "eremed",
    clue: "Compensate for the faults or bad aspects of.",
  },
  {
    actual: "transportation",
    scrambled: "atropinsrottan",
    clue:
      "The action of transporting someone or something or the process of being transported.",
  },
  {
    actual: "millennium",
    scrambled: "leiminlmun",
    clue: "A period of a thousand years.",
  },
  {
    actual: "spectrum",
    scrambled: "percstum",
    clue: "A band of colours, as seen in a rainbow.",
  },
  {
    actual: "oasis",
    scrambled: "sosai",
    clue: "A fertile spot in a desert, where water is found.",
  },
  {
    actual: "schedule",
    scrambled: "eheduscl",
    clue:
      "A plan for carrying out a process or procedure, giving lists of intended events and times.",
  },
  {
    actual: "flourish",
    scrambled: "huisflor",
    clue: "Grow or develop in a healthy or vigorous way.",
  },
  {
    actual: "conservative",
    scrambled: "centavosrive",
    clue: "Averse to change or innovation and holding traditional values.",
  },
  {
    actual: "broadcast",
    scrambled: "troadscab",
    clue: "Transmit by radio or television.",
  },
  {
    actual: "miracle",
    scrambled: "criaelm",
    clue:
      "An extraordinary and welcome event that is not explicable by natural or scientific laws.",
  },
  {
    actual: "continue",
    scrambled: "ncuitneo",
    clue: "Persist in an activity or process.",
  },
  {
    actual: "pumpkin",
    scrambled: "munkipp",
    clue: "Associated with Halloween.",
  },
  {
    actual: "parsley",
    scrambled: "pryseal",
    clue:
      "A small plant with flat or curly leaves that are used for flavouring.",
  },
  {
    actual: "spreadsheet",
    scrambled: "sparthesdee",
    clue:
      "A file that exists of cells in rows and columns and can help arrange, calculate and sort data.",
  },
  {
    actual: "dictionary",
    scrambled: "docairnyit",
    clue: "A reference book on a particular subject.",
  },
  {
    actual: "imprint",
    scrambled: "nimript",
    clue: "Impress or stamp a mark or outline on a surface.",
  },
  {
    actual: "citrus",
    scrambled: "csrtui",
    clue:
      "A tree of a genus that includes citron, lemon, lime, orange, and grapefruit.",
  },
  {
    actual: "subtle",
    scrambled: "elbuts",
    clue: "So delicate or precise as to be difficult to analyse or describe.",
  },
  {
    actual: "machine",
    scrambled: "cahmine",
    clue:
      "An apparatus using mechanical power and having several parts, each with a definite function and together performing a particular task.",
  },
  {
    actual: "special",
    scrambled: "salicpe",
    clue: "Better, greater, or otherwise different from what is usual.",
  },
  {
    actual: "palindrome",
    scrambled: "pminoredal",
    clue:
      "A word, phrase, or sequence that reads the same backwards as forwards.",
  },
  {
    actual: "dormitory",
    scrambled: "trdiymoor",
    clue: "A large bedroom for a number of people in a school or institution.",
  },
];
export const LEVEL_9 = [
  {
    actual: "inconvenient",
    scrambled: "eviteinnonnc",
    clue: "Causing trouble, difficulties, or discomfort.",
  },
  {
    actual: "grandeur",
    scrambled: "uderrgan",
    clue: "Splendour and impressiveness, especially of appearance or style.",
  },
  {
    actual: "magistrate",
    scrambled: "metristaga",
    clue: "An official entrusted with administration of the laws.",
  },
  {
    actual: "gregarious",
    scrambled: "gougerrias",
    clue: "Sociable.",
  },
  {
    actual: "appetite",
    scrambled: "tetepipa",
    clue: "A natural desire to satisfy a bodily need, especially for food.",
  },
  {
    actual: "miscellaneous",
    scrambled: "linoleumsaesc",
    clue: "Composed of members or elements of different kinds.",
  },
  {
    actual: "humongous",
    scrambled: "ungumsoho",
    clue: "Huge.",
  },
  {
    actual: "prestigious",
    scrambled: "surgiestpoi",
    clue: "Inspiring respect and admiration.",
  },
  {
    actual: "myriad",
    scrambled: "dimyar",
    clue: "A countless or extremely great number of people or things.",
  },
  {
    actual: "perspective",
    scrambled: "privetscepe",
    clue: "A point of view.",
  },
  {
    actual: "culinary",
    scrambled: "anyucirl",
    clue: "Something related to food or cooking.",
  },
  {
    actual: "aggregate",
    scrambled: "tergagage",
    clue: "A whole formed by combining several separate elements.",
  },
  {
    actual: "inaugurate",
    scrambled: "taguaniure",
    clue: "Begin or introduce.",
  },
  {
    actual: "affiliation",
    scrambled: "finifilaoat",
    clue: "The state or process of affiliating or being affiliated.",
  },
  {
    actual: "conquest",
    scrambled: "oncetsuq",
    clue:
      "The subjugation and assumption of control of a place or people by military force.",
  },
  {
    actual: "apprehension",
    scrambled: "papishereonn",
    clue: "Anxiety or fear that something bad or unpleasant will happen.",
  },
  {
    actual: "minuscle",
    scrambled: "incusmel",
    clue: "Extremely small.",
  },
  {
    actual: "precipitation",
    scrambled: "pecorinipitta",
    clue:
      "Rain, snow, sleet, or hail that falls to or condenses on the ground.",
  },
  {
    actual: "meander",
    scrambled: "enarmde",
    clue: "To turn in different directions.",
  },
  {
    actual: "accommodate",
    scrambled: "cadetmocamo",
    clue: "Provide lodging or sufficient space for.",
  },
  {
    actual: "mesmerize",
    scrambled: "rezesmime",
    clue: "Capture the complete attention of.",
  },
  {
    actual: "pedestrian",
    scrambled: "anestriped",
    clue: "A person walking rather than travelling in a vehicle.",
  },
  {
    actual: "trivial",
    scrambled: "litirav",
    clue: "Of little value or importance.",
  },
  {
    actual: "butterfly",
    scrambled: "terfbutyl",
    clue:
      "A nectar-feeding insect with two pairs of large, typically brightly coloured wings that are covered with microscopic scales.",
  },
  {
    actual: "mosaic",
    scrambled: "oiscam",
    clue:
      "A picture or pattern produced by arranging together small pieces of stone, tile, glass, etc.",
  },
];
export const LEVEL_10 = [
  {
    actual: "archipelago",
    scrambled: "golecharpai",
    clue: "An extensive group of islands.",
  },
  {
    actual: "acknowledgement",
    scrambled: "cawkentledgemon",
    clue: "Acceptance.",
  },
  {
    actual: "jurisdiction",
    scrambled: "isocitrinjud",
    clue: "The official power to make decisions.",
  },
  {
    actual: "considerate",
    scrambled: "andesiteorc",
    clue: "Careful not to incovenience others.",
  },
  {
    actual: "pompous",
    scrambled: "moopups",
    clue: "Grand.",
  },
  {
    actual: "magnificent",
    scrambled: "fmanniticeg",
    clue: "Extremely beautiful.",
  },
  {
    actual: "wonderful",
    scrambled: "feldornuw",
    clue: "Extremely good.",
  },
  {
    actual: "annihilation",
    scrambled: "lathinionani",
    clue: "Complete destruction.",
  },
  {
    actual: "meritorius",
    scrambled: "simouterri",
    clue: "Deserving reward or praise.",
  },
  {
    actual: "precision",
    scrambled: "piconesir",
    clue: "The quality of being exact and accurate.",
  },
  {
    actual: "cantonment",
    scrambled: "cemontannt",
    clue: "A military camp.",
  },
  {
    actual: "designation",
    scrambled: "onsgidenati",
    clue: "Act of pointing someone out with name or title.",
  },
  {
    actual: "possibility",
    scrambled: "obtipsilyis",
    clue: "A thing that may happen.",
  },
  {
    actual: "melancholy",
    scrambled: "lylochanme",
    clue: "A feeling of sadness with no obvious cause.",
  },
  {
    actual: "boisterous",
    scrambled: "susobotier",
    clue: "Noisy.",
  },
  {
    actual: "cornucopia",
    scrambled: "uproacnoic",
    clue:
      "A large horn-shaped container which is a symbol of abundance and nourishment.",
  },
  {
    actual: "camaraderie",
    scrambled: "arcaamreied",
    clue:
      "Mutual trust and friendship among people who spend a lot of time together.",
  },
  {
    actual: "renaissance",
    scrambled: "nsarecinase",
    clue: "A revival or renewed interest in something.",
  },
  {
    actual: "gargantuan",
    scrambled: "uanngtarga",
    clue: "Enormous.",
  },
  {
    actual: "sobriquet",
    scrambled: "reqsobuit",
    clue: "A person's nickname.",
  },
  {
    actual: "razzmatazz",
    scrambled: "ztazmazraz",
    clue: "Exciting activity and display designed to attract and impress.",
  },
  {
    actual: "epiphany",
    scrambled: "apyineph",
    clue: "An experience of a sudden and striking realization.",
  },
  {
    actual: "colloquial",
    scrambled: "liquallcoo",
    clue: "Language used for informal conversation.",
  },
  {
    actual: "centenarian",
    scrambled: "annancierte",
    clue: "A person who is a hundred years old or more.",
  },
  {
    actual: "psyche",
    scrambled: "chyeps",
    clue: "The human soul, mind or spirit.",
  },
];
export const WrongCount = 5;
export const MaxScore = 250;

export const getWords = (level) => {
  let words = "";
  switch (level) {
    case 1:
      words = LEVEL_1;
      break;
    case 2:
      words = LEVEL_2;
      break;
    case 3:
      words = LEVEL_3;
      break;
    case 4:
      words = LEVEL_4;
      break;
    case 5:
      words = LEVEL_5;
      break;
    case 6:
      words = LEVEL_6;
      break;
    case 7:
      words = LEVEL_7;
      break;
    case 8:
      words = LEVEL_8;
      break;
    case 9:
      words = LEVEL_9;
      break;
    case 10:
      words = LEVEL_10;
      break;
    default:
      words = [];
  }
  return words;
};